import React, { Suspense } from 'react';
import { useRecoilValue } from 'recoil';
import { useTranslation } from 'react-i18next';
import { Container, Grid, List } from '@mui/material';
import { RvHookup } from '@mui/icons-material';
import { ListItemLink } from 'components/mui/ListItemLink';
import { CompanyType } from 'models/CompanyModel';
import UpcomingVoyages from 'modules/dashboard/cards/UpcomingVoyages';
import BalanceAndInvoices from 'modules/dashboard/cards/BalanceAndInvoices';
import CarAggregate from 'modules/dashboard/cards/CarAggregate';
import Cars from 'modules/cars/Cars';
import auth from 'recoil/atoms/auth';


const DashboardInner = () => {
    const my = useRecoilValue(auth);
    const {t} = useTranslation('cars');

    if (my.permissions.has('cars view dashboard'))
        return (
            <Cars/>
        );

    return (
        <Container maxWidth="lg" sx={{my: 4}}>
            <Grid container spacing={2}>
                {my.permissions.has('statistics view') && (
                    <CarAggregate/>
                )}

                {my.permissions.has('invoices view') && (
                    <Grid item xs={12} sm={6}>
                        <BalanceAndInvoices/>
                    </Grid>
                )}

                {my.permissions.has('voyages view') && (
                    <Grid item xs={12} sm={6}>
                        <UpcomingVoyages/>
                    </Grid>
                )}

                {my.type === CompanyType.TransportAgent && (
                    <List>
                        <ListItemLink
                            to={'/transportation'}
                            primary={t('transportation')}
                            icon={<RvHookup/>}
                        />
                    </List>
                )}
            </Grid>
        </Container>
    );
};

const Dashboard = () => {
    return (
        <Suspense fallback={null}>
            <DashboardInner />
        </Suspense>
    )
}

export default Dashboard;
